import { Navigate } from "react-router-dom";
import { useAdmin } from "@/hooks/useAdmin";
import { Skeleton } from "./ui/skeleton";

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export const AdminProtectedRoute = ({ children }: AdminProtectedRouteProps) => {
  const { isAdmin, isLoading, user } = useAdmin();

  console.debug("[AdminProtectedRoute] state", { isAdmin, isLoading, hasUser: !!user });

  // Show loading skeleton while checking auth status
  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-16 space-y-4" role="status" aria-live="polite">
        <Skeleton className="h-12 w-64" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  // If not logged in at all, redirect to login
  if (!user) {
    console.warn("[AdminProtectedRoute] no user session, redirecting to /admin/login");
    return <Navigate to="/admin/login" replace />;
  }

  // If logged in but not admin, redirect to home
  if (!isAdmin) {
    console.warn("[AdminProtectedRoute] user is not admin, redirecting to /");
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
